<template>
    <div class="advantage">
        <div class="headline">{{ $t('headline.title1') }}</div>
        <div class="advantages">
            <div class="advantageItem" v-for="(item, index) in 6" :key="index">
                <div class="advantageImg">
                    <img :src="`https://4d-ai.chat/img/ys${index + 1}.png`">
                </div>
                <div class="describe">
                    <div class="title">{{ $t(`technology.title${index + 1}`) }}</div>
                    <div class="content">{{ $t(`technology.content${index + 1}`) }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
        }
    },
    beforeDestroy() {

    },
    mounted() {

    },
    methods: {}
}
</script>
<style scoped>
@media (max-width: 768px) {
    .headline {
        font-size: 18px !important;
        margin-bottom: 10px !important;
    }

    .advantage {
        padding: 10px !important;
    }

    .advantageItem {
        width: 100% !important;
        margin-bottom: 15px !important;
        padding: 10px !important;
    }

    .title {
        font-size: 12px !important;
    }

    .content {
        font-size: 12px !important;
    }

    .advantageItem:nth-child(6) {
        margin-bottom: 0 !important;
    }

    .advantageImg {
        width: 50px !important;
        height: 50px !important;
        border-radius: 10px !important;
    }

    .describe {
        padding-left: 10px !important;
    }
}
</style>
<style scoped lang="less">
.headline {
    font-weight: 600;
    font-size: 36px;
    color: #243c8a;
    text-align: center;
    margin-bottom: 64px;
}

.advantage {
    background-color: #f9fafb;
    padding: 80px 212px;
    box-sizing: border-box;

    .advantages {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .advantageItem:hover {
            box-shadow: 0 2px 50px #0000001a;
            transform: translate(0, -10px)
        }

        .advantageItem:nth-child(5) {
            margin-bottom: 0;
        }

        .advantageItem:nth-child(6) {
            margin-bottom: 0;
        }

        .advantageItem {
            width: calc(50% - 15px);
            padding: 32px;
            box-sizing: border-box;
            box-shadow: 0 2px 8px #0000001a;
            display: flex;
            align-items: center;
            border-radius: 15px;
            transition: all 0.3s;
            margin-bottom: 30px;

            .describe {
                flex: 1;
                padding-left: 24px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;

                .title {
                    font-size: 20px;
                    color: #243c8a;
                    font-weight: 600;
                    margin-bottom: 12px;
                }

                .content {
                    color: #4c5563;
                    font-size: 16px;
                }
            }

            .advantageImg {
                width: 64px;
                height: 64px;
                background-color: #ddeafe;
                border-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 80%;
                    height: 80%;
                }
            }
        }
    }
}
</style>